export default __webpack_public_path__ + "static/media/26_4_0.aca41ad1.png";